"use client";

import React from "react";
import { MapPin, Phone, Mail, Facebook, Instagram, ShieldCheck, Award, Wrench, BatteryCharging } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((val, i) => <li key={val} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </ul>;
  }
  try {
    const links = Array.isArray(menuItems) && menuItems.length > 0 ? menuItems : [{
      id: "1",
      label: "Patinetes Eléctricos",
      href: "/ScootersPage"
    }, {
      id: "2",
      label: "Bicicletas Eléctricas",
      href: "/BicyclesPage"
    }, {
      id: "3",
      label: "Servicios de Reparación",
      href: "/ServicesPage"
    }, {
      id: "4",
      label: "Contacto",
      href: "/ContactPage"
    }];
    return <ul className="space-y-3">
        {links.map((item, i) => <li key={item.id} data-index={i}>
            <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors font-sans text-sm flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-lg bg-primary/50" />
              {item.label}
            </Link>
          </li>)}
      </ul>;
  } catch (error) {
    console.error("FooterMenuConsumer failed to render:", error);
    return null;
  }
}
export default function Footer() {
  try {
    const currentYear = new Date().getFullYear();
    const whatsappNumber = "34624990509";
    return <footer id="footer" className="dark bg-background text-foreground border-t border-border pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-16">
            
            <div className="space-y-6">
              <Link to="/" className="inline-block">
                <img src="/img/reparacion_de_baterias_en_sevilla.png" alt="BateríasSevilla - Reparación de baterías de litio en Sevilla, Andalucía y España." title="BateríasSevilla" className="h-7 w-auto" height="28" width="auto" />
              </Link>
              <p className="text-muted-foreground font-sans text-sm leading-relaxed">
                Reparación de baterías de litio en Sevilla, Andalucía y España. Especialistas en diagnóstico, equilibrado, reparación, BMS y reconstrucción con servicio técnico profesional y envíos nacionales.
              </p>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626966/img/reparar_bateria_patinete_electrico.png" alt="BateríasSevilla - Expertos en reparación de baterías de litio en Sevilla, Andalucía y España." title="BateríasSevilla" className="rounded-lg w-full h-32 object-cover border border-border/50" height="128" width="auto" />
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <BatteryCharging className="size-4 text-primary" />
                <span>Diagnóstico Avanzado BMS</span>
              </div>
            </div>

            <div className="space-y-6">
              <h3 className="font-default text-lg font-semibold tracking-tight text-foreground">
                Enlaces Rápidos
              </h3>
              <MenuProvider menu_id="17">
                <FooterMenuConsumer />
              </MenuProvider>
            </div>

            <div className="space-y-6">
              <h3 className="font-default text-lg font-semibold tracking-tight text-foreground">
                Contacto Directo
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3 text-muted-foreground font-sans text-sm">
                  <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                  <span>Mairena del Aljarafe, Sevilla, Aljarafe, España</span>
                </li>
                <li className="flex items-center gap-3 text-muted-foreground font-sans text-sm">
                  <Phone className="size-5 text-primary shrink-0" />
                  <Link to="tel:+34624990509" className="hover:text-primary transition-colors" newTab>
                    +34 624 990 509
                  </Link>
                </li>
                <li className="flex items-center gap-3 text-muted-foreground font-sans text-sm">
                  <Mail className="size-5 text-primary shrink-0" />
                  <Link to="mailto:reparacionbateriaspatinete@gmail.com" className="hover:text-primary transition-colors" newTab>
                    reparacionbateriaspatinete@gmail.com
                  </Link>
                </li>
              </ul>
              <p className="text-muted-foreground font-sans text-sm leading-relaxed">
                Reparación de baterías de litio en Sevilla, Andalucía y España con diagnóstico, equilibrado y reconstrucción profesional.
              </p>
              <p className="text-muted-foreground font-sans text-sm leading-relaxed">
                Servicio técnico especializado con cobertura regional en Andalucía y envíos nacionales seguros para todo tipo de baterías.
              </p>
              <Button asChild variant="outline" className="w-full sm:w-auto border-primary/50 hover:bg-primary/10 text-foreground">
                <Link to={`https://wa.me/${whatsappNumber}`} newTab>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626966/img/whatsapp_icon.png" alt="Contactar por WhatsApp para reparación de baterías en Sevilla" className="size-4 mr-2" />
                  WhatsApp Directo
                </Link>
              </Button>
              <p className="text-muted-foreground font-sans text-sm mt-4">
                Contacta con BateríasSevilla para un diagnóstico profesional y presupuesto personalizado.
              </p>
              <p className="text-muted-foreground/50 font-sans text-[10px] mt-2 leading-tight">
                reparación baterías Sevilla, reparar batería patinete Sevilla, servicio técnico baterías Andalucía, arreglo baterías España.
              </p>
            </div>

            <div className="space-y-6">
              <h3 className="font-default text-lg font-semibold tracking-tight text-foreground">
                Garantía y Calidad
              </h3>
              <div className="flex flex-wrap gap-2">
                <Badge variant="secondary" className="bg-secondary/50 border-border py-1.5 px-3">
                  <ShieldCheck className="size-3.5 mr-1.5 text-primary" />
                  Certificado de Calidad
                </Badge>
                <Badge variant="secondary" className="bg-secondary/50 border-border py-1.5 px-3">
                  <Award className="size-3.5 mr-1.5 text-primary" />
                  Garantía 6 Meses
                </Badge>
                <Badge variant="secondary" className="bg-secondary/50 border-border py-1.5 px-3">
                  <Wrench className="size-3.5 mr-1.5 text-primary" />
                  Técnicos Expertos
                </Badge>
              </div>
              
              <div className="pt-4">
                <h4 className="font-default text-sm font-medium text-foreground mb-3">Síguenos</h4>
                <div className="flex items-center gap-3">
                  <Button variant="ghost" size="icon" className="rounded-lg bg-secondary/50 hover:bg-primary hover:text-primary-foreground transition-colors" asChild>
                    <Link to="#" aria-label="Facebook">
                      <Facebook className="size-4" />
                    </Link>
                  </Button>
                  <Button variant="ghost" size="icon" className="rounded-lg bg-secondary/50 hover:bg-primary hover:text-primary-foreground transition-colors" asChild>
                    <Link to="#" aria-label="Instagram">
                      <Instagram className="size-4" />
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <Separator className="bg-border/50" />

          <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-muted-foreground font-sans text-xs text-center md:text-left">
              &copy; {currentYear} BateríasSevilla. Todos los derechos reservados.
            </p>
            <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-xs text-muted-foreground font-sans">
              <Link to="#" className="hover:text-primary transition-colors">Aviso Legal</Link>
              <Link to="#" className="hover:text-primary transition-colors">Política de Privacidad</Link>
              <Link to="#" className="hover:text-primary transition-colors">Política de Cookies</Link>
              <Link to="#" className="hover:text-primary transition-colors">Términos y Condiciones</Link>
            </div>
          </div>
        </div>
      </footer>;
  } catch (error) {
    console.error("Footer section failed to render:", error);
    return null;
  }
}